export type IdpWebKey = 'FG' | 'ST' | 'BF'
export type IdpSiteId = 0 | 1 | 2

export const SITE_TO_WEB_KEY: Record<string, IdpWebKey> = { '0': 'FG', '1': 'ST', '2': 'BF' }
export const WEB_KEY_TO_SITE: Record<IdpWebKey, IdpSiteId> = { FG: 0, ST: 1, BF: 2 }
export const ALL_IDP_WEB_KEYS: IdpWebKey[] = ['FG', 'ST', 'BF']

export function webKeysForFilter(filterSite: string): IdpWebKey[] {
  if (filterSite === 'all') return ALL_IDP_WEB_KEYS
  return [SITE_TO_WEB_KEY[filterSite] || 'BF']
}

export function initialFilterSiteFromSearch(search: string, defaultSite: string): string {
  const queryWebKey = new URLSearchParams(search || '').get('webKey') as IdpWebKey | null
  if (queryWebKey && WEB_KEY_TO_SITE[queryWebKey] !== undefined) {
    return String(WEB_KEY_TO_SITE[queryWebKey])
  }
  return defaultSite
}
